import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import api from './api';

export interface DadosRateio {
  id: string;
  status: string;
  statusCodigo: number;
  valorBm: string;
  valorBmNumber: number;
  valorCc: string;
  valorReatear: number;
  valorOi: string;
  valorOm: string;
  valorADistribuir: string;
  valotTotal: number;
  valorTotalFormatado: string;
  valorTotaItemRateavelBm: string;
  valoradistribuir: string;
  aditivoVigenteDataCriacaoBm?: number;
  aditivoVigenteAtual?: number;

  aditivoVigenteDataCriacaoBmString: string;
  aditivoVigenteAtualString: string;
  planilhaTotais: PlanilhaTotais;

  createdAt?: Date;
  updatedAt?: Date;
}

export interface PlanilhaTotais {
  somaTotal: number;
  somaAnterior: number;
  somaMedicao: number;
  somaAcumulado: number;
  somaSaldo: number;
  linhas: LinhaPlanilhaTotais[];
}

export interface LinhaPlanilhaTotais {
  bmTotvs: BmTotvs;
  index: number;
  valorMedicao: number;
  valorAcumulado: number;
  saldo: number;
}

export interface BmTotvs {
  id: string;
  item: string;
  descricao: string;
  unidade: string;

  precoUnitario: number;
  precoUnitarioFormatado: string;

  valorTotal: number;
  valorTotalFormatado: string;

  anterior: number;
  anteriorFormatado: string;

  valorMedicao: number;
  valorMedicaoFormatado: string;

  acumulado: number;
  acumuladoFormatado: string;

  saldoLinha: number;
  saldoLinhaFormatado: string;
}

export interface PlanilhaRateioCommandResult {
  id: string;
  numero: number;
  total: number;
  status: string;
  statusCodigo: number;
  totalFormatado: string;
  linhaPlanilhaRateioResult: LinhaPlanilhaRateioResult[];
  linhaItemRateavelBmPlanilhaRateioResult: LinhaItemRateavelBmResult[];
  totalARatear: number;
  totalRateio: number;
  totalCc: number;
  totalOi: number;
  totalOm: number;
  totalCr: number;
  municipioId: string;
  tipoDocumentoCobrancaId: string;
  municipioNome: string;
  tipoDocumentoCobrancaNome: string;
  PisCofins: boolean;
}

export interface LinhaItemRateavelBmResult {
  id: string;
  index: number;
  descricao: string;
  un: string;
  valor?: number;
  linhaItemRateavelBmId: string;
  planilhaRateioId: string;
  bmItemNumero: string;
}

export interface LinhaPlanilhaRateioResult {
  id: string;
  index: number;
  oiOuCc?: string;
  numero?: number;
  natureza?: number;
  valor?: number;
  valorFormatado?: string;
  valorString?: number;
  tipoCodigo: number;
  tipoNome: string;
}

export interface TipoLinhaPlanilhaRateio {
  id: string;
  nome: string;
  codigo: number;
}

export interface VerificarDocumentoAutorizacao {
  id: string;
  possuiDocumentosAutorizacao: boolean;
}

export const getAllTipoLinhaPlanilhaRateio = () =>
  api.get<TipoLinhaPlanilhaRateio[]>(`rateios/getAllTipoLinhaPlanilhaRateio`);

export const getRateioByMedicaoId = (medicaoId: any) =>
  api.get<DadosRateio>(`rateios/getRateioByMedicaoId/${medicaoId}`);
export const getRateioStatusByMedicaoId = (medicaoId: any) =>
  api.get<any>(`rateios/getRateioStatusByMedicaoId/${medicaoId}`);
export const getRateioBmTotvsByMedicaoId = (medicaoId: any) =>
  api.get<BmTotvs[]>(`rateios/getRateioBmTotvsByMedicaoId/${medicaoId}`);
export const getPlanilhaRateioBmByMedicaoId = (medicaoId: any) =>
  api.get<PlanilhaRateioCommandResult[]>(`rateios/getPlanilhaRateioBmByMedicaoId/${medicaoId}`);

export const getAllTipoLinhaPlanilhaRateioOptions = () =>
  getAllTipoLinhaPlanilhaRateio().then(tipoLinhaPlanilhaRateio =>
    (tipoLinhaPlanilhaRateio || []).map(item => ({ text: item.nome, value: item.id.toString(), codigo: item.codigo })),
  );

export const updateLinhaItemRateioValor = (id: string, valor?: number) =>
  api.put<any>(`rateios/updateLinhaItemRateioValor`, { id, valor });

export const updateLinhaPlanilhaRateio = (id: any, form: any) =>
  api.put<any>(`rateios/updateLinhaPlanilhaRateio/`, form);

export const updateLinhaPlanilhaRateioMatriz = (form: any) =>
  api.put<any>(`rateios/updateLinhaPlanilhaRateioMatriz/`, form);

export const updateTabelaTotvs = (id: any, form: any) => api.put<any>(`rateios/updateTabelaTotvs/`, form);

export const voltarRateioPendente = (id: any, form: any) =>
  api.put<any>(`rateios/VoltarRateioPendente/${id}`, form);


export const creatNovaPlanilha = (form: any) => {
  return api.post<any>(`rateios/creatNovaPlanilha/`, form);
};
export const creatNovaPlanilhaRateioErdadaBmAnterior = (form: any) => {
  return api.post<any>(`rateios/creatHerdaPlanilhaBmAnterior/`, form);
};

export const deletePlanilhaRateio = (id: any) => api.delete<any>(`planilhaRateios/deletePlanilhaRateio/${id}`);
export const creatNewLinePlanilha = (id: any) => api.post<any>(`planilhaRateios/creatNewLinePlanilha/${id}`);
export const deleteLinePlanilha = (id: any) => api.delete<any>(`planilhaRateios/deleteLinePlanilha/${id}`);

export const enviarParaTotvs = (id: any) => api.post<any>(`rateios/enviarParaTotvs/${id}`);

export const importarPlanilha = (form: any) => api.post<any>(`planilhaRateios/importPlanilha`, form);

export const downloadModelo = () => {
  const urlBase = window.location.origin + '/api/planilhaRateios/dowloadModeloImportacao';
  const nomeArquivo = 'MODELO - Matriz de Rateio SGC.xlsx';

  trackPromise(
    Axios.get(urlBase, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const validarDocumentosAutorizacao = (id: any) => api.get<VerificarDocumentoAutorizacao>(`rateios/buscarDocumentosAutorizacao/${id}`);

export const ExportarPlanilhaRateio = (id: any) => {
  let urlBase = window.location.origin;
  Axios.get(urlBase + `/api/planilhaRateios/exportarPlanilhaRateioExcel/${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ExportacaoPlanilhaRateio.xlsx');
    link.setAttribute('id', 'download_PlanilhaRateio');
    document.body.appendChild(link);
    link.click();
    document.getElementById('download_PlanilhaRateio').outerHTML = '';
  });
};